<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="regulador.especialidades"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
export default {
    data: () => ({
        fields: [
            { key: 'codigo', label: 'Código', sortable: true, class: 'col-min' },
            { key: 'nome', label: 'Nome', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        destroy(especialidade) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir a especialidade?',
                async () => this.regulador.especialidades.splice(this.regulador.especialidades.indexOf(especialidade), 1)
            )
        }
    },
    props: {
        regulador: { type: Object, required: true },
    }
}
</script>